import SearchIcon from '@mui/icons-material/Search'
import InputBase, { InputBaseProps } from '@mui/material/InputBase'
import { styled } from '@mui/material/styles'

export default function UsersSearch({ search, setSearch }) {
  const onSearchChange: InputBaseProps['onChange'] = (event) => {
    setSearch(event.target.value)
  }

  return (
    <SearchBox>
      <InputBase
        name="user"
        placeholder="ユーザーの絞り込み"
        inputProps={{ 'aria-label': 'search for user' }}
        value={search}
        onChange={onSearchChange}
        data-testid="search-user"
      />
      <SearchIcon color="action" />
    </SearchBox>
  )
}

const SearchBox = styled('label')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: 'solid 2px',
  borderColor: theme.palette.grey[400],
  borderRadius: 18,
  paddingLeft: 16,
  paddingRight: 16,
  height: 36,
}))
